export const PROMO_PACKAGE_ID = '42a10617-063d-11ee-a009-0242ac190008';
